import { useEffect, useState } from 'react';
import { TIMEPICKER } from '../constant/Constant';
import { saveTime2ViewTime } from '../util/TimeTableUtil';

import DatePicker from 'react-datepicker';
import setHours from 'date-fns/setHours';
import { format } from 'date-fns';
import setMinutes from 'date-fns/setMinutes';
import 'react-datepicker/dist/react-datepicker.css';

const TimePickerBox = ({ title, value, size, onChangeTimeString, disabled = false, minMax = true }) => {
    const [startDate, setStartDate] = useState(null);

    useEffect(() => {
        if (value != undefined) {
            let date = new Date();
            date = setHours(date, value.slice(0, 2));
            date = setMinutes(date, value.slice(2, 4));
            setStartDate(date);
        }
    }, [value]);

    return (
        <div
            className={
                'form-box ' +
                (size != undefined ? (size == 'small' ? ' w-sm' : size == 'medium' ? ' w-md' : ' w-lg') : ' w-140')
            }
        >
            <div className='input-box'>
                <label htmlFor={title}>{title}</label>
                <div className='input-group'>
                    <DatePicker
                        className='form-control ipt-date'
                        // className='form-control ipt-date w-140'
                        disabled={disabled}
                        selected={startDate}
                        onChange={(date) => {
                            onChangeTimeString(format(date, 'HHmm'));
                            setStartDate(date);
                        }}
                        // dropdownMode='select' // 'scroll' | 'select' | undefined;
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={5}
                        // timeCaption='Time'
                        dateFormat='HH:mm' // 화면의 시간 포맷
                        timeFormat='HH:mm' // dropdown 시간 포맷
                        minTime={minMax && setHours(setMinutes(new Date(), 0), 8)} // hidden 하는 방법은 설정으로는 없는 듯 함.
                        maxTime={minMax && setHours(setMinutes(new Date(), 0), 23)}
                    />
                </div>
            </div>
        </div>
    );
};

// const TimePickerBox = ({ title, value, size, onChange, disabled = false }) => {
//     return (
//         <div
//             className={
//                 'form-box' +
//                 (size != undefined ? (size == 'small' ? ' w-sm' : size == 'medium' ? ' w-md' : ' w-lg') : '')
//             }
//         >
//             <div className='input-box'>
//                 <label htmlFor={title}>{title}</label>
//                 <div className='input-group'>
//                     <input
//                         id={title}
//                         type='time'
//                         className='form-control ipt-date w-140'
//                         disabled={disabled}
//                         value={value && saveTime2ViewTime(value)}
//                         onChange={(e) => onChange(e)}
//                     />
//                 </div>
//             </div>
//         </div>
//     );
// };

export default TimePickerBox;
